import React from 'react';
import { useTranslation } from 'react-i18next';

export default function GlobalFooter() {
  const { t, i18n } = useTranslation('translation');
  const isFrench = i18n.resolvedLanguage?.startsWith('fr') || i18n.language?.startsWith('fr');

  const localizedUrl = (englishUrl, frenchUrl) => (isFrench ? frenchUrl : englishUrl);

  return (
    <div className="global-footer" sx={{ position: 'absolute', bottom: 0 }}>
      <footer id="wb-info">
        <div className="landscape">
          <nav className="container wb-navcurr">
            <h2 className="wb-inv">{t("About government")}</h2>
            <ul className="list-unstyled colcount-sm-2 colcount-md-3">
              <li><a href={localizedUrl("http://contact-contactez.nrcan-rncan.gc.ca/index.cfm?lang=eng&context=[current-page:url:args:first]", "http://contact-contactez.nrcan-rncan.gc.ca/index.cfm?lang=fra&context=[current-page:url:args:first]")}>{t("Contact us")}</a></li>
              <li><a href={localizedUrl("https://www.canada.ca/en/government/dept.html", "https://www.canada.ca/fr/gouvernement/min.html")}>{t("Departments and agencies")}</a></li>
              <li><a href={localizedUrl("https://www.canada.ca/en/government/publicservice.html", "https://www.canada.ca/fr/gouvernement/fonctionpublique.html")}>{t("Public service and military")}</a></li>
              <li><a href={localizedUrl("https://www.canada.ca/en/news.html", "https://www.canada.ca/fr/nouvelles.html")}>{t("News")}</a></li>
              <li><a href={localizedUrl("https://www.canada.ca/en/government/system/laws.html", "https://www.canada.ca/fr/gouvernement/systeme/lois.html")}>{t("Treaties, laws and regulations")}</a></li>
              <li><a href={localizedUrl("https://www.canada.ca/en/transparency/reporting.html", "https://www.canada.ca/fr/transparence/rapports.html")}>{t("Government-wide reporting")}</a></li>
              <li><a href={localizedUrl("https://pm.gc.ca/en", "https://pm.gc.ca/fr")}>{t("Prime Minister")}</a></li>
              <li><a href={localizedUrl("https://www.canada.ca/en/government/system.html", "https://www.canada.ca/fr/gouvernement/systeme.html")}>{t("About government")}</a></li>
              <li><a href={localizedUrl("https://open.canada.ca/en", "https://ouvert.canada.ca/fr")}>{t("Open government")}</a></li>
            </ul>
          </nav>
        </div>
        <div className="brand">
          <div className="container">
            <div className="row">
              <nav className="col-md-9 col-lg-10 ftr-urlt-lnk">
                <h2 className="wb-inv">{t("About this site")}</h2>
                <ul>
                  <li><a href={localizedUrl("https://www.canada.ca/en/social.html", "https://www.canada.ca/fr/sociaux.html")}>{t("Social media")}</a></li>
                  <li><a href={localizedUrl("https://www.canada.ca/en/mobile.html", "https://www.canada.ca/fr/mobile.html")}>{t("Mobile applications")}</a></li>
                  <li><a href={localizedUrl("https://www.canada.ca/en/government/about.html", "https://www.canada.ca/fr/gouvernement/a-propos.html")}>{t("About Canada.ca")}</a></li>
                  <li><a href={localizedUrl("https://www.nrcan.gc.ca/terms-and-conditions/10847", "https://ressources-naturelles.canada.ca/avis/10847")}>{t("Terms and conditions")}</a></li>
                  <li><a href={localizedUrl("https://www.canada.ca/en/transparency/privacy.html", "https://www.canada.ca/fr/transparence/confidentialite.html")}>{t("Privacy")}</a></li>
                </ul>
              </nav>
              <div className="col-xs-6 visible-sm visible-xs tofpg">
                <a href="#wb-cont">{t("Top of Page")} <span className="glyphicon glyphicon-chevron-up"></span></a>
              </div>
              <div className="col-xs-6 col-md-3 col-lg-2 text-right">
                <img src="https://wet-boew.github.io/themes-dist/GCWeb/GCWeb/assets/wmms-blk.svg" alt={t("Symbol of the Government of Canada")} />
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
